import {
  CATEGORY_FORM_TYPE_SLOTS,
  VISIT_CATEGORIES,
} from "../Assignments/constants/assignments.constants";
import type { ReplacedSlot, SaveFormResponseData } from "@/api/form-builder/formBuilder.types";
import { showWarningAlert } from "@/utils/responseHandler";

const EXTRA_WORK_ORDER_TYPE_LABELS: Record<string, string> = {
  survey: "Survey",
  recurring: "Recurring",
};

const UNKNOWN_WORK_ORDER_TYPE = "Unknown work order type";

export function getWorkOrderTypeLabel(workOrderType: string | null): string {
  if (typeof workOrderType !== "string" || workOrderType === "") return UNKNOWN_WORK_ORDER_TYPE;
  const key = workOrderType.toLowerCase();
  return (
    VISIT_CATEGORIES.find((meta) => meta.value === key)?.label ??
    EXTRA_WORK_ORDER_TYPE_LABELS[key] ??
    workOrderType
  );
}

export function formatReplacedSlot(slot: ReplacedSlot): string {
  const formTypeLabel =
    CATEGORY_FORM_TYPE_SLOTS.find((s) => s.formType === slot.formType)?.label ?? slot.formType;
  const parts = [getWorkOrderTypeLabel(slot.workOrderType), formTypeLabel];
  if (slot.tradeId != null) parts.push(`Trade #${slot.tradeId}`);
  if (slot.subtradeId != null) parts.push(`Subtrade #${slot.subtradeId}`);
  return `${parts.join(" / ")}: replaced ${slot.previousFormName}`;
}

/** Warns (persistently) when publishing a global form took over platform default slots. */
export function notifyReplacedSlots(saveResponseData: unknown): void {
  if (saveResponseData == null || typeof saveResponseData !== "object") return;
  const { replacedSlots } = saveResponseData as SaveFormResponseData;
  if (!Array.isArray(replacedSlots)) return;

  const lines: string[] = [];
  for (const slot of replacedSlots) {
    try {
      if (slot == null || typeof slot !== "object") continue;
      lines.push(formatReplacedSlot(slot));
    } catch {
      // malformed entry: skip so publish success handling never breaks
    }
  }
  if (lines.length === 0) return;

  showWarningAlert(
    `This global form replaced the platform default for the following slots; the previous forms were deactivated for all tenants. ${lines.join("; ")}`,
    "Platform Defaults Replaced",
    false,
  );
}
